/**
 * Guardia delle rotte di amministrazione.
 *
 * **Non è una misura di sicurezza**, ed è importante non scambiarla per tale:
 * l'autorizzazione la concede `requireAdmin` lato server, su ogni richiesta,
 * leggendo `ADMIN_EMAILS`. Chi forzasse `isAdmin` nel proprio client vedrebbe una
 * pagina che non riesce a caricare alcun dato.
 *
 * Serve invece a non mostrare a un utente normale una schermata fatta solo di
 * errori 403, che è il modo peggiore di dire «questa sezione non è per te».
 *
 * Va annidata **dentro** `ProtectedRoute`: senza sessione ripristinata `user` è
 * ancora `null` e un reindirizzamento immediato manderebbe alla dashboard anche
 * un amministratore che ricarica la pagina.
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/auth-context';

export function AdminRoute({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  if (!user?.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
